// extracted by mini-css-extract-plugin
module.exports = {"root":"DurationField_root__wWUBu"};